var _filter, _filter2, _rect, _ellipse, _text, _text2, _path, _circle, _circle2, _circle3, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg03WebrtcDirect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 800 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "peerGradA",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#10b981"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#059669"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "peerGradB",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#8b5cf6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#7c3aed"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "connectionGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#10b981"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#06b6d4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#8b5cf6"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "glowGreen",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "shadowDeep",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 6,
    stdDeviation: 12,
    floodOpacity: 0.25
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 400,
    fill: "#0f172a"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 400,
    cy: 200,
    rx: 350,
    ry: 150,
    fill: "#1e293b",
    opacity: 0.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 40,
    textAnchor: "middle",
    fill: "#f8fafc",
    fontFamily: "system-ui, sans-serif",
    fontSize: 26,
    fontWeight: "bold"
  }, "\n    WebRTC Direct Communication\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 68,
    textAnchor: "middle",
    fill: "#22c55e",
    fontFamily: "system-ui, sans-serif",
    fontSize: 15
  }, "\n    \u2713 No server in between \u2014 Peer-to-Peer\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 220 200 C 350 200, 450 200, 580 200",
    stroke: "url(#connectionGrad)",
    strokeWidth: 8,
    fill: "none",
    strokeLinecap: "round",
    filter: "url(#glowGreen)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,1000;400,1000",
    dur: "2s",
    fill: "freeze"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 8,
    fill: "#34d399"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1.5s",
    repeatCount: "indefinite",
    path: "M 220 200 C 350 200, 450 200, 580 200"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.5;1",
    dur: "0.5s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 8,
    fill: "#a78bfa"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1.5s",
    repeatCount: "indefinite",
    path: "M 580 200 C 450 200, 350 200, 220 200"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.5;1",
    dur: "0.5s",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 5,
    fill: "#06b6d4"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "0.5s",
    path: "M 220 200 C 350 200, 450 200, 580 200"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(130, 200)",
    filter: "url(#shadowDeep)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -80,
    y: -70,
    width: 160,
    height: 140,
    rx: 20,
    fill: "url(#peerGradA)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -65,
    y: -55,
    width: 130,
    height: 110,
    rx: 12,
    fill: "#064e3b",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -45,
    y: -40,
    width: 90,
    height: 60,
    rx: 6,
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40,
    y: -35,
    width: 80,
    height: 8,
    rx: 3,
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -30,
    cy: -31,
    r: 3,
    fill: "#ef4444"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -18,
    cy: -31,
    r: 3,
    fill: "#fbbf24"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -6,
    cy: -31,
    r: 3,
    fill: "#22c55e"
  }), /*#__PURE__*/React.createElement("text", {
    y: 50,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 18,
    fontWeight: "bold"
  }, "\n      Peer A\n    "))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(670, 200)",
    filter: "url(#shadowDeep)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -80,
    y: -70,
    width: 160,
    height: 140,
    rx: 20,
    fill: "url(#peerGradB)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -65,
    y: -55,
    width: 130,
    height: 110,
    rx: 12,
    fill: "#2e1065",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -45,
    y: -40,
    width: 90,
    height: 60,
    rx: 6,
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40,
    y: -35,
    width: 80,
    height: 8,
    rx: 3,
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -30,
    cy: -31,
    r: 3,
    fill: "#ef4444"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -18,
    cy: -31,
    r: 3,
    fill: "#fbbf24"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -6,
    cy: -31,
    r: 3,
    fill: "#22c55e"
  }), /*#__PURE__*/React.createElement("text", {
    y: 50,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 18,
    fontWeight: "bold"
  }, "\n      Peer B\n    "))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 155)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: -18,
    width: 120,
    height: 36,
    rx: 18,
    fill: "#06b6d4",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    y: 6,
    textAnchor: "middle",
    fill: "#22d3ee",
    fontFamily: "system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600
  }, "\n      Direct P2P\n    "))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 340)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -280,
    y: -25,
    width: 560,
    height: 50,
    rx: 12,
    fill: "#022c22"
  }), /*#__PURE__*/React.createElement("text", {
    y: 8,
    textAnchor: "middle",
    fill: "#6ee7b7",
    fontFamily: "system-ui, sans-serif",
    fontSize: 15
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#22c55e"
  }, "\u26A1"), " Low Latency  \n      ", /*#__PURE__*/React.createElement("tspan", {
    dx: 30,
    fill: "#22c55e"
  }, "\uD83D\uDD12"), " Encrypted  \n      ", /*#__PURE__*/React.createElement("tspan", {
    dx: 30,
    fill: "#22c55e"
  }, "\uD83D\uDCC8"), " Scalable  \n      ", /*#__PURE__*/React.createElement("tspan", {
    dx: 30,
    fill: "#22c55e"
  }, "\uD83C\uDFA5"), " Real-time Media\n    "))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 95)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: -35,
    y: -18,
    width: 70,
    height: 36,
    rx: 8,
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("text", {
    y: 6,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12
  }, "Server"), /*#__PURE__*/React.createElement("line", {
    x1: -40,
    y1: 0,
    x2: 40,
    y2: 0,
    stroke: "#ef4444",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg03WebrtcDirect);
export default __webpack_public_path__ + "static/media/03-webrtc-direct.aae14491fba0349c8c19c582cad81610.svg";
export { ForwardRef as ReactComponent };